import React from "react";
import { XMarkIcon, StarIcon } from "@heroicons/react/24/solid";
import { useState } from "react";
import { baseURL } from '../../../lib/axios';


const ProductDetailModal = ({ product, onClose }) => {
  const [mainImage, setMainImage] = useState(null);

  if (!product) return null;

  const images = JSON.parse(product.images);
  if (!mainImage) setMainImage(images[0]);

  const formatPrice = (price) => {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "XOF",
    }).format(price);
  };

  const renderRating = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <StarIcon
          key={i}
          className={`h-5 w-5 ${i <= rating ? "text-yellow-400" : "text-gray-300"}`}
        />
      );
    }
    return stars;
  };

  return (
    <div className="fixed inset-0 bg-black/30  flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10">
          <h2 className="text-xl font-bold text-gray-800">{product.name}</h2>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-100"
          >
            <XMarkIcon className="h-6 w-6 text-gray-500" />
          </button>
        </div>

        {/* Content */}
        <div className="grid md:grid-cols-2 gap-6 p-6">
          {/* Gallery */}
          <div>
            <div className="mb-4 rounded-lg  overflow-hidden bg-gray-100">
              <img
                // src={mainImage}
                src={`${baseURL}/storage/${mainImage}`}
                alt={product.name}
                className="w-full h-80 object-cover"
              />
            </div>
            <div className="grid grid-cols-4 gap-2">
              {images.map((img, index) => (
                <button
                  key={index}
                  onClick={() => setMainImage(img)}
                  className={`rounded-md overflow-hidden border-2 ${
                    mainImage === img ? "border-primary" : "border-transparent"
                  }`}
                >
                  <img
                    src={`${baseURL}/storage/${img}`}
                    alt={`Vue ${index + 1}`}
                    className="w-full h-20 object-cover"
                  />
                </button>
              ))}
            </div>
          </div>

          {/* Details */}
          <div>
            {/* Shop & Rating */}
            <div className="flex justify-between items-start mb-4">
              <div>
                <span className="text-sm text-gray-500">Vendu par</span>
                <h3 className="font-medium text-gray-800">{product.shop.name}</h3>
              </div>
              <div className="text-right">
                <div className="flex items-center">
                  {renderRating(product.average_rating)}
                  <span className="ml-1 text-sm text-gray-600">
                    ({product.average_rating.toFixed(1)})
                  </span>
                </div>
                <span className="text-sm text-gray-500">
                  {product.stock} en stock
                </span>
              </div>
            </div>

            {/* Price */}
            <div className="mb-6">
              <span className="text-sm text-gray-500">Prix</span>
              <div className="flex items-baseline gap-2">
                <span className="text-3xl font-bold text-primary">
                  {formatPrice(product.price)}
                </span>
                {product.commission_price && (
                  <span className="text-sm text-gray-400 line-through">
                    {formatPrice(product.commission_price)}
                  </span>
                )}
              </div>
            </div>

            {/* Description */}
            <div className="mb-6">
              <h3 className="font-medium text-gray-800 mb-2">Description</h3>
              <p className="text-gray-600 whitespace-pre-line">
                {product.description}
              </p>
            </div>

            {/* Actions */}
           

            {/* Additional Info */}
            <div className="mt-6 pt-6 border-t border-gray-200">
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <span className="text-gray-500">Catégorie</span>
                  <p className="text-gray-800">Nom de catégorie</p>
                </div>
                <div>
                  <span className="text-gray-500">Référence</span>
                  <p className="text-gray-800">#{product.id}</p>
                </div>
                <div>
                  <span className="text-gray-500">Date d'ajout</span>
                  <p className="text-gray-800">
                    {new Date(product.created_at).toLocaleDateString("fr-FR")}
                  </p>
                </div>
                <div>
                  <span className="text-gray-500">Statut</span>
                  <p className="text-gray-800 capitalize">{product.status}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailModal;